import {useEffect, useState} from 'react';
import Sidebar from './Sidebar';
import {USER_PATHS} from '../../../config';
import {Link} from "react-router-dom";
import {CheckMobile} from "../../../AppSystem/Helpers/CheckMobile";
import {SaveLocalStorage} from "../../../Common/Helpers/SaveLocalStorage";
import { CheckUserRole } from '../../../AppSystem/Helpers/CheckUserRole';
import {SelectOrganization} from "../../../Common/Components/SelectOrganization/SelectOrganization";
import LogoLRF from '../../../AppSystem/assets/img/LRF-new-logo.png';
import {useTranslation} from "react-i18next";
import {CheckUserOrganization} from "../../../AppSystem/Helpers/CheckUserOrganization";
import {LoadLocalStorage} from "../../../Common/Helpers/LoadLocalStorage";
import { useSelector } from 'react-redux';
import { MobileNav } from './MobileNav';


export function VerticalSidebar({/*onMenuClick*/}) {
  const {orgData, rolesData} = useSelector(state => state.auth);
  const { t } = useTranslation();
  const [isToggle, setIsToggle] = useState(false);
  const isMobile = CheckMobile(998);
  const windowWidthPrincipalPage = CheckMobile(1106); //1024
  const [elementHeight , setElementHeight] = useState(0)

  const tToggle = () => {
    const body = document.getElementById('sideBar');
    const content = document.getElementById('contentId');

    if (!body) return;

    if (window.screen.width <= 998) {
      body.classList.toggle('sidebar-enable');
      body.classList.remove('right-bar-enabled');
      body.classList.toggle('vertical-collpsed');
     // document.getElementById('title-breadcrumb').classList.toggle('ps-5')
      if (content) {
        content.classList.toggle('ps-custom-content-page');
      }
    } else {
      body.classList.toggle('sidebar-enable');
      body.classList.toggle('vertical-collpsed');
      body.classList.remove('right-bar-enabled');
      body.setAttribute('data-sidebar-size', 'sm');
    }
    setIsToggle(!isToggle);
    setCheckClick(false);
  };
  useEffect(() => {
    const body = document.getElementById('sideBar');
    if (!body) return;

    if(windowWidthPrincipalPage === true) {
      body.classList.add('vertical-collpsed-mobile');
    } else {
      body.classList.remove('vertical-collpsed-mobile');
    }

  }, [windowWidthPrincipalPage]);

    // else {
  //   const body = document.getElementById('sideBar');
  //   body.classList.remove('vertical-collpsed-mobile');
  // }
  useEffect(() => {
    const sidebarMenu = document.getElementById('sidebar-menu');
    if (!sidebarMenu) return;

    if(windowWidthPrincipalPage === true) {
      sidebarMenu.classList.add('vertical-collpsed-text');
    }else {
      sidebarMenu.classList.remove('vertical-collpsed-text');
    }

  }, [windowWidthPrincipalPage]);

  // Condition for scroll class
  const screenHeight =50; //820 ,500

  useEffect(() => {
    const initialCheck = () => {
      const sidebarElement = document.getElementById('sidebar-menu-scroll');
      if (sidebarElement) {
        setElementHeight(sidebarElement.offsetHeight)
      }
    }
    initialCheck();
  }, []); //elementHeight

  const isAdmin = CheckUserRole(rolesData, 'Admin');
  const [checkClick, setCheckClick] = useState(false)
  const checkUser = CheckUserOrganization(orgData);
  const search = LoadLocalStorage("search");

  return (
    <>
      <div className="vertical-menu vh-100" id="sideBar">
        <div className={`${isToggle === true ? 'p-1 navbar-brand-box-toggle ':'navbar-brand-box '}`}>
          <Link to={USER_PATHS.APP} className="logo text-white" onClick={() => {
            SaveLocalStorage('headerTitle', t("dashboard.dashboard"));
            if (search) {
              localStorage.removeItem('search');
            }
            localStorage.removeItem('currentPage');
            localStorage.removeItem('itemsPerPage');

            // REMOVE LOCAL STORAGE FROM INTERNAL TRANSACTION
            if (window.location.href.includes("internal-transaction") === false) {
              localStorage.removeItem('originOrgId');
              localStorage.removeItem('message');
            }
          }}>
            <span className='d-flex justify-content-center w-100' style={{padding: '0.5rem 0'}}>
              {!windowWidthPrincipalPage ?
                  <img src={LogoLRF} alt={t('accessibility.logo')} className={`img-fluid ${isToggle === true ? 'size-img-logo-sm': 'size-img-logo'}`}/>

                  :
                  <img src={LogoLRF} alt={t('accessibility.logo')} className={`img-fluid size-img-logo-sm ${isToggle === true ? '' : 'd-none' }`}/>}
              
            </span>
          </Link>
          <div className='bg-sidebar-select d-flex justify-content-center'>
              <li className='dropdown list-unstyled'>
                {isToggle && !windowWidthPrincipalPage ? <i className=' bx bx-buildings fs-5 p-icon-selectOrg icono-boton' onClick={() => setCheckClick(!checkClick)}></i>
                    :
                    ''}
                {isToggle ?
                    <ul className='metismenu list-unstyled'>
                      <li>
                        <div className={`${!windowWidthPrincipalPage ? (checkClick === true ? 'sub-menu-especial-select' : 'd-none' ) : ''}`}>
                          <SelectOrganization/>
                        </div>
                      </li>
                    </ul>
                    :
                    <ul className='metismenu list-unstyled'>
                      <li>
                        <div className={windowWidthPrincipalPage === true ? 'd-none' : ''}>
                          <SelectOrganization/>
                        </div>
                      </li>
                    </ul>
                }
              </li>
          </div>
        </div>
        {!isMobile && (
          <button
             id="closeHamburger"
            type="button"
            className={`btn btn-sm px-3 header-item ${isToggle === true ?'vertical-menu-btn' :'vertical-menu-btn-toggle'} topnav-hamburger `}
            onClick={() => {
              tToggle();

              const topbar = document.getElementById('page-topbar');
              const footer = document.getElementById('footer');
              const content = document.getElementById('contentId');
              const sidebarMenu = document.getElementById('sidebar-menu');

              if (isToggle) {
                if (topbar) topbar.classList.remove('header-margin-left');
                if (footer) footer.classList.remove('footer-margin-left');
                // document.getElementById('footer').classList.remove('width-footer-toggle');
                // document.getElementById('footer').classList.add('width-footer');
                if (content) content.classList.remove('main-content-margin-left');
                if (windowWidthPrincipalPage && sidebarMenu) {
                  sidebarMenu.classList.remove('vertical-collpsed-text');
                  sidebarMenu.classList.add('d-none');

                }

              } else {
                if (topbar) topbar.classList.add('header-margin-left');
                if (footer) footer.classList.add('footer-margin-left');
                // document.getElementById('footer').classList.add('width-footer-toggle');
                // document.getElementById('footer').classList.remove('width-footer');
                if (content) content.classList.add('main-content-margin-left');

                if (windowWidthPrincipalPage && sidebarMenu) {
                  sidebarMenu.classList.remove('vertical-collpsed-text');
                  sidebarMenu.classList.remove('d-none');
                }
              }
            }}
          >
            {isToggle === true ? (
                windowWidthPrincipalPage ?
                    <i className={`bx bx-x text-secondary fs-3 `} style={{ position: 'absolute', left: -35, top: 5 }} />
                    :
                    <i className={`bx bx-right-arrow-alt text-secondary fs-3 `} style={{ position: 'absolute', left: 0 }} /> /*top-icon-menu-arrow*/
            ) : (
              <div className="hamburger-icon position-fixed top-icon-menu">
                <span></span>
                <span></span>
                <span></span>
              </div>
            )}
          </button>
        )}
        <div id="sidebar-menu-scroll" className={
          !windowWidthPrincipalPage ?
            (checkUser === true
                ? elementHeight > screenHeight && !isToggle
                    ? 'sidebar-menu-scroll-on position-relative bg-sidebar' /*aqui hay que añadir lo de la altura del sidebar*/
                    : 'sidebar-menu-scroll position-relative bg-sidebar'
                : 'sidebar-menu-scroll-without-org position-relative bg-sidebar')
            :
            ('position-relative sidebar-menu-scroll-on bg-sidebar')

          }>
          <div className="" id="sidebar-menu">
              
              {isMobile ? <MobileNav /> : <Sidebar toggle={isToggle} /* onMenuClick={onMenuClick}*//>}
              {isAdmin ? <h6 className="pt-4 text-center">{isToggle === true ? 'S-A' : t('adminLabel.systemAdmin')}</h6> : ''}
          </div>
        </div>
      </div>
    </>
  );
}
